export const Moment = (component) => {
  const hasBackground = component.querySelector(".moment__background") || component.querySelector(".moment__foreground");

  if (hasBackground) {
    component.querySelector(".moment__mediaSection").classList.add("moment__mediaSection--hasBg");
  }
};
